/* -----------------Third parties--------------- */
import { Button, List, type ListItemProps } from "react-native-paper";

import { ExamContextListItem } from "@features/dashboard/";
import { Box } from "@memorang/ui";
import ProductIcon from "components/ProductIcon";
import { useTranslation } from "react-i18next";
import type { ViewStyle } from "react-native";
import AudioPlaybackTestSwitch from "./AudioPlaybackTestSwitch";
/* -----------------Child components--------------- */
import DarkModeSwitch from "./DarkModeSwitch";

/* -----------------Props--------------- */
type Props = {
	type?: string;
	icon: string;
	options?: {
		title: string;
		description: string;
	}[];

	iconRight?: string;
} & ListItemProps;

/* -----------------Component--------------- */
const AccountListSection = (props: Props) => {
	const { type, title, description, icon, onPress, iconRight } = props;
	const { t } = useTranslation();

	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	const renderLeft = (p: any) => {
		if (icon.includes(".")) {
			return (
				<Box {...p.style}>
					<ProductIcon image={icon} size={34} />
				</Box>
			);
		}
		return <List.Icon {...p} icon={icon} />;
	};
	const renderRight = (propsRight: {
		color: string;
		style?: ViewStyle;
	}) => {
		if (type === "toggle") {
			return <DarkModeSwitch />;
		}
		if (type === "toggle-audio-playback") {
			return <AudioPlaybackTestSwitch />;
		}
		if (type === "extend-subscription") {
			return (
				<Button mode="text" onPress={onPress}>
					{t("account.extendValidity")}
				</Button>
			);
		}
		if (iconRight) {
			return <List.Icon {...propsRight} icon={iconRight} />;
		}

		return null;
	};

	const RenderListitem = () => (
		<List.Item
			title={title}
			description={description}
			onPress={onPress}
			style={{
				paddingLeft: 0,
				paddingRight: 16,
				cursor: onPress ? "pointer" : "auto",
			}}
			left={renderLeft}
			right={renderRight}
		/>
	);
	switch (type) {
		case "exam-filter":
			return <ExamContextListItem title={title as string} icon={icon} />;
		default:
			return <RenderListitem />;
	}
};

export default AccountListSection;
